import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowLeft, Package } from "lucide-react";
import CreateResourceRegForm from "./CreateResourceRegForm";
import "../../GisincidentManagement/ViewIncident/ViewIncident.css";

const CreateResource = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { state } = useLocation();
  const inEdit = state?.edit;

  return (
    <div style={{ margin: "8px", fontFamily: "'Poppins', 'Segoe UI', sans-serif" }}>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@500;600;700;800&display=swap');`}</style>
      <div className="incv-header-banner">
        <button type="button" className="incv-back-btn" onClick={() => navigate(-1)} aria-label="Back">
          <ArrowLeft size={16} />
        </button>
        <span className="incv-header-icon">
          <Package size={14} color="#fff" />
        </span>
        <div>
          <div className="incv-header-title">{inEdit ? t("Edit Resource Details") : t("Create Resource")}</div>
          <div className="incv-header-subtitle">{inEdit ? "Update resource details" : "Register a new resource"}</div>
        </div>
      </div>
      <div style={{ marginTop: "10px", backgroundColor: "#fff", borderRadius: "10px", padding: "20px 16px" }}>
        <CreateResourceRegForm inEdit={inEdit} />
      </div>
    </div>
  );
};

export default CreateResource;
